/* ============================================================
   Background pre-roll scrub.
   Maps scroll across the hero (one viewport) -> video.currentTime,
   so the joint finishes rolling right as you scroll past the hero
   into the page content. (The page is long; mapping to the whole
   page would scrub the roll in slow motion.)
   Respects prefers-reduced-motion (static final frame).
   ============================================================ */
(function () {
  "use strict";

  var prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  var video = document.querySelector(".roll-video");
  var fallback = document.querySelector(".roll-fallback");
  var hero = document.querySelector(".hero");
  if (!video) return;

  if (prefersReduced) return;

  var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) ||
              (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
  if (isIOS) {
    document.documentElement.classList.add("is-ios");
    if (fallback) fallback.style.display = "block";
    video.style.display = "none";
    return;
  }

  var duration = 0;
  var ready = false;
  var scheduled = false;
  var lastSeek = -1;
  var primed = false;
  var hasRAF = typeof window.requestAnimationFrame === "function";

  function clamp(v, lo, hi) { return v < lo ? lo : v > hi ? hi : v; }

  function getProgress() {
    var scrubEnd = (hero ? hero.offsetHeight : 0) || window.innerHeight;
    if (scrubEnd <= 0) return 1;
    return clamp(window.scrollY / scrubEnd, 0, 1);
  }

  function render() {
    scheduled = false;
    if (!ready) return;
    var t = clamp(getProgress() * duration, 0, duration - 0.04);
    if (Math.abs(t - lastSeek) > 0.008) {
      try { video.currentTime = t; } catch (e) { /* not seekable yet */ }
      lastSeek = t;
    }
  }

  function onScroll() {
    render();
    if (hasRAF && !scheduled) {
      scheduled = true;
      requestAnimationFrame(render);
    }
  }

  function start() {
    if (ready) return;
    duration = video.duration;
    if (!duration || !isFinite(duration)) return;
    ready = true;
    video.pause();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
    render();
  }

  function prime() {
    if (primed) return;
    primed = true;
    var pr = video.play();
    if (pr && typeof pr.then === "function") {
      pr.then(function () { video.pause(); }).catch(function () {});
    } else {
      try { video.pause(); } catch (e) {}
    }
  }
  ["touchstart", "pointerdown", "wheel", "keydown"].forEach(function (ev) {
    window.addEventListener(ev, prime, { once: true, passive: true });
  });

  if (video.readyState >= 1 && video.duration) {
    start();
  } else {
    video.addEventListener("loadedmetadata", start, { once: true });
    video.addEventListener("loadeddata", start, { once: true });
    video.addEventListener("canplay", start, { once: true });
  }

  video.addEventListener("error", function () {
    if (fallback) fallback.style.display = "block";
    video.style.display = "none";
  });
})();

// Background videos (mission + journey hero): autoplay loop, static under reduced motion
(function () {
  var vids = document.querySelectorAll(".mission__bg, .journey-hero__video");
  if (!vids.length) return;
  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  vids.forEach(function (v) {
    if (reduced) {
      try { v.pause(); v.removeAttribute("autoplay"); } catch (e) {}
      return;
    }
    function kick() {
      if (!v.paused) return;
      var p = v.play();
      if (p && typeof p.catch === "function") p.catch(function () {});
    }
    kick();
    document.addEventListener("visibilitychange", function () {
      if (!document.hidden) kick();
    });
    ["pointerdown", "touchstart", "keydown", "scroll"].forEach(function (ev) {
      window.addEventListener(ev, kick, { passive: true });
    });
  });
})();

// Filter the live Workable job list by state (location tiles) or department (team tiles)
(function () {
  var hook = document.getElementById("whr_embed_hook");
  if (!hook) return;
  var locationLinks = document.querySelectorAll(".location__link");
  var teamLinks = document.querySelectorAll(".team-card__link");

  var status = null;
  function ensureStatus() {
    if (status && status.isConnected) return status;
    status = document.createElement("p");
    status.className = "role-filter";
    var head = document.querySelector(".roles__head");
    if (head) head.appendChild(status);
    else hook.parentNode.insertBefore(status, hook);
    return status;
  }
  function showAll() {
    var items = hook.querySelectorAll(".whr-item");
    for (var i = 0; i < items.length; i++) items[i].style.display = "";
    if (status) status.style.display = "none";
  }
  function setStatus(html) {
    var s = ensureStatus();
    s.style.display = "";
    s.innerHTML = html;
    var reset = s.querySelector(".role-filter__reset");
    if (reset) reset.addEventListener("click", showAll);
  }

  var RESET_BTN = ' <button type="button" class="role-filter__reset">See all roles</button>';

  function applyFilter(childSelector, needle, foundMsg, noneMsg) {
    var items = hook.querySelectorAll(".whr-item");
    if (!items.length) return;
    var shown = 0;
    for (var i = 0; i < items.length; i++) {
      var el = items[i].querySelector(childSelector);
      var txt = el ? el.textContent.toLowerCase() : "";
      var match = txt.indexOf(needle) !== -1;
      items[i].style.display = match ? "" : "none";
      if (match) shown++;
    }
    setStatus((shown === 0 ? noneMsg : foundMsg) + RESET_BTN);
  }

  for (var i = 0; i < locationLinks.length; i++) {
    (function (a) {
      a.addEventListener("click", function () {
        var state = a.getAttribute("data-state");
        setTimeout(function () {
          applyFilter(".whr-location", state.toLowerCase(),
            "Showing roles in " + state + ".",
            "No current openings in " + state + " right now.");
        }, 60);
      });
    })(locationLinks[i]);
  }

  for (var j = 0; j < teamLinks.length; j++) {
    (function (a) {
      var dept = a.getAttribute("data-dept");
      a.addEventListener("click", function () {
        if (!dept) { showAll(); return; }
        setTimeout(function () {
          applyFilter(".whr-dept", dept.toLowerCase(),
            "Showing " + dept + " roles.",
            "No current " + dept + " openings right now.");
        }, 60);
      });
    })(teamLinks[j]);
  }
})();
